/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sanction_Sub_StallingInputs */



/**
* | output |
* | --- |
* | "Stalling" |
*
* @param {Sanction_Sub_StallingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const sanction_sub_stalling = /** @type {((inputs?: Sanction_Sub_StallingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sanction_Sub_StallingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Temporisation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Dilación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Enrolação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Temporeggiamento")
	return /** @type {LocalizedString} */ ("Stalling")
});